import styled from 'styled-components'
import api from '../axios.js';
import { useEffect,useState } from 'react';
import Cards from './juegos/cards.jsx';
import { reventasRedux } from '../redux/actions/reventaActions.js';
import { pais } from '../redux/actions/paisActions.js';
import { useDispatch,useSelector } from 'react-redux'
import MenuSuperior from './menuSuperior.jsx'
import LateralCategorias from './lateralCategorias.jsx'
import Backdrop from '@mui/material/Backdrop';
import JuegoOfertaDetalle from './juegoOfertaDetalle.jsx'
import LoginShoppingCart from './shoppingCart/loginShoppingCart.jsx'
import { setLocation } from '../services/utilities.js'

const Container=styled.div`
	background-color:#050505;
	
	overflow:hidden;
	font-family: "Poppins", sans-serif;
	background-size:cover
`;

const MenuInferior=styled.div`
	display:flex;
	justify-content: space-between;
	height:93vh;
	`;



const ContainerCards=styled.div`
	height:100%;
	width:84vw;
	display:flex;
	overflow :auto;
	&::-webkit-scrollbar{
		display:none;
  	}
 `;


	
export default function JuegosOferta(){
	let reventas=useSelector(state=>state.reventa.reventas);
	let paisData=useSelector(state=>state.pais.pais);
	let estadoShoppingCart=useSelector(state=>state.shoppingCart.Estado);
	let estadoSolicitud=useSelector(state=>state.solicitud.estadoSolicitud);
	const [openState,setOpenState]=useState({juego:{},state:false});
	const [openLoginShoppingCart,setOpenLoginShoppingCart]=useState(false);
	let [ data,setData ]=useState([]);
	let [ filtroNombre,setFiltroNombre ] = useState("");
	let [ filtroConsola,setFiltroConsola ] = useState("");
	let [ filtroPlayers,setFiltroPlayers ] = useState("");
	let [ filtroCategoria,setFiltroCategoria ] = useState("");
	let dispatch=useDispatch();
	
	

	useEffect(()=>{
				let location=async()=>{
	 		let rsp=await setLocation();
	 		dispatch(pais(rsp));
	 		localStorage.setItem('paisNombre', rsp.nombre);
	 		localStorage.setItem('moneda', rsp.moneda);
	 		localStorage.setItem('monedaIcono', rsp.monedaIcono);
	 		localStorage.setItem('ISO', rsp.ISO);
	 		localStorage.setItem('bandera', rsp.bandera);
	 		};

	 	if(estadoShoppingCart===0&&estadoSolicitud===0){
	 		try{	
	 	 		api.get(`/reventa/sale`)
	 	 		.then(response=>response)
	 	 		.then(response=>dispatch(reventasRedux(response.data))); 	 	
	 		}catch(err){console.log(err)};
	 	}		


	 	if(!localStorage.getItem('paisNombre')){
	 		try{	 	 	
	 			location();
	 		}catch(err){console.log(err)}
	 	} 	 	
 	},[dispatch,estadoShoppingCart,estadoSolicitud]);
	
	
	useEffect(()=>{
		let temp = [];
 		if (reventas) {
    		temp = reventas.filter(reventa => {
      			const juego = reventa.Cuenta_Juego.Juego;
      			
      		// Verifica si el nombre y consola cumplen con los filtros
      			const nombreMatches = juego.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
      			const consolaMatches = filtroConsola.includes(reventa.consola);
      			const playersMatches = filtroPlayers.includes(juego.multiplayerOffLine);

      		// Verifica si las categorías cumplen con los filtros
      			const categoriasMatches = filtroCategoria.length > 0 
        		? juego.Categoria.some(cate => filtroCategoria.includes(cate.nombre))
        		: true;
      		
      		return nombreMatches && consolaMatches && playersMatches && categoriasMatches && reventa.publicar_reventa;
    		});
  		}
  		setData(temp);
	},[reventas,filtroNombre,filtroConsola,filtroCategoria,filtroPlayers]);


 	let handleClose=()=>{
 		setOpenState( {state:false,juego:{}} )
 	};

 	let handleOpen=(juego)=>{
 		setOpenState( {state:true,juego:juego} )
 	};

 	let handleCloseLoginShoppingCart=()=>{
 		setOpenLoginShoppingCart( false )
 	};

 	let handleOpenLoginShoppingCart=()=>{
 		setOpenLoginShoppingCart( true )
 	};

	
	return(
		<Container>
			<MenuSuperior filtroNombre={setFiltroNombre} openLoginShoppingCart={handleOpenLoginShoppingCart} />

			<MenuInferior>
				<LateralCategorias filtroConsola={setFiltroConsola} filtroCategorias={setFiltroCategoria} filtroPlayers={setFiltroPlayers}/>
				<ContainerCards>
					<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={openState.state}  > 
		  				
		  				{openState.state?<JuegoOfertaDetalle juego={openState.juego} close={handleClose}/ >:null}
		  				
     	 			</Backdrop>
     	 			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={openLoginShoppingCart}  > 
		  				
		  				{openLoginShoppingCart?<LoginShoppingCart  close={handleCloseLoginShoppingCart} />:null}
		  				
     	 			</Backdrop>     	 			
					{data.length>0&&paisData?<Cards reventas={data} open={handleOpen}/>:null}
				</ContainerCards>
		 	</MenuInferior>	
		 			</Container>
		)
}  